/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ZoneCreate { 
    Name: string;
    AreaId: string;
    Width: number;
    Height: number;
    X: number;
    Y: number;
}

